import { biLoggerFactory } from 'wix-private';
 
const msid = '76d22e68-19c6-4be0-a5dc-c754c52f1115';
 
const biGroupsLoggers = {
    19: biLoggerFactory('lp', 19, { msid }),
    'fb-ads-lp': biLoggerFactory('fb-ads-lp', 19, { msid })
}
 
export async function fireBIEvent(src, evid, fields) {
 
    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}
